import WordsInput from './wordsInput.vue'
import WkSelect from './wkSelect.vue'
import WkRadioGroup from './wkRadioGroup.vue'
import WkTitle from './wkTitle.vue'
import WkCheckBoxGroup from './wkCheckBoxGroup.vue'
import DynamicDate from './dynamicDate.vue'
import RadioDesc from './radioDesc.vue'
import WkRemoteSelect from './wkRemoteSelect.vue'
import WkText from './wkText.vue'
import WkBlockText from './wkBlockText.vue'
import WkModalForm from './wkModalForm.vue'
import WkHonorModalForm from './wkHonorModalForm.vue'
import WkDropTime from './wkDropTime.vue'
import WkRangFixedTime from './wkRangFixedTime.vue'
import WkButton from './wkButton.vue'
import WkListCheck from './wkListCheck.vue'
import AdsRemoteSelect from './adsRemoteSelect.vue'
import WkHonorProductConfig from './wkHonorProductConfig.vue'
export { 
    WordsInput, WkSelect, DynamicDate, WkRadioGroup, WkCheckBoxGroup, RadioDesc, WkTitle , WkRemoteSelect,
    WkText, WkBlockText, WkModalForm, WkDropTime, WkRangFixedTime, WkButton, WkListCheck, AdsRemoteSelect,
    WkHonorModalForm, WkHonorProductConfig
};
export const FORM_ITEM_TYPE = {
    WordsInput: WordsInput.name,
    WkSelect: WkSelect.name,
    WkRadioGroup: WkRadioGroup.name,
    WkCheckBoxGroup: WkCheckBoxGroup.name,
    DynamicDate: DynamicDate.name,
    WkTitle: WkTitle.name,
    RadioDesc: RadioDesc.name,
    WkRemoteSelect: WkRemoteSelect.name,
    WkText: WkText.name,
    WkBlockText: WkBlockText.name,
    WkModalForm: WkModalForm.name,
    WkDropTime: WkDropTime.name,
    WkRangFixedTime: WkRangFixedTime.name,
    WkButton: WkButton.name,
    WkListCheck: WkListCheck.name,
    AdsRemoteSelect: AdsRemoteSelect.name,
    WkHonorModalForm: WkHonorModalForm.name,
    WkHonorProductConfig: WkHonorProductConfig.name,
}